import Spinner from '@/components/Spinner';

const PageLoading = ({ text = 'Loading...' }) => {
  return (
    <div className={'comp-page-loading'}>
      <Spinner />
      <div>{text}</div>
    </div>
  );
};

export default PageLoading;
